/* HomeMedix cart drawer (Oct 2026). See snippets/hm-cart-desktop.liquid.
   1. Desktop: lifts <cart-drawer> to <body>, so no header stacking context can sit on top of it.
   2. Moves "Not ready yet? / Email yourself this cart / talk line" (.hm-cd-div / .hm-cd-save / .hm-cd-talk) from the footer
      into the scrolling item list on desktop, and back into the footer on phones (the bottom sheet orders them itself).
   3. Empty cart: drops the #hm-cdd-empty-tpl template into the drawer (Dawn's empty block is hidden on desktop by CSS).
   4. All widths: Shopify keeps a fixed slot per wallet inside its closed shadow DOM, so hiding PayPal / Google Pay
      (hm-cart-desktop.css) leaves blank space under Shop Pay. Slides the visible wallets (Shop Pay, Apple Pay) to the
      top of the box and trims the box to them. No-op if Shopify stops exposing the wallet elements.
   5. Header cart icon: if the page loads with an empty cart and the header shows Dawn's bag icon, swaps in the same
      cart icon the header uses when the cart has items (sections/cart-icon-bubble.liquid now does this for re-renders).
   Dawn re-renders the drawer's HTML on every cart change, so a MutationObserver (+ a ResizeObserver for the wallets,
   which render late) re-applies 2-4. */
(function () {
  if (window.__hmCdd) return;
  window.__hmCdd = true;
  var MQ = window.matchMedia('(min-width: 750px)');
  var WALLETS = 'shop-pay-wallet-button, shopify-apple-pay-button', GAP = 10;
  var CART_IMG = 'https://cdn.shopify.com/s/files/1/0600/4568/8925/files/Shopping--cart.svg?v=1755275879';
  var raf = 0, ro = null;
  function later() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; sync(); }); }
  if (window.ResizeObserver) ro = new ResizeObserver(function () { later(); });
  function watch(el) { if (ro && !el.__hmRo) { el.__hmRo = true; ro.observe(el); } }
  function drawer() { return document.querySelector('cart-drawer'); }
  function cartIcon() {
    var b = document.getElementById('cart-icon-bubble'), s = b && b.querySelector('svg.icon-cart-empty');
    if (!s) return;
    var img = document.createElement('img');
    img.alt = '';
    img.src = CART_IMG;
    s.parentNode.replaceChild(img, s);
  }
  function compact(d) {
    var hosts = d.querySelectorAll('shopify-accelerated-checkout-cart'), h, i;
    for (h = 0; h < hosts.length; h++) {
      var host = hosts[h], hr = host.getBoundingClientRect(), els = host.querySelectorAll(WALLETS), vis = [];
      watch(host);
      for (i = 0; i < els.length; i++) {
        watch(els[i]);
        var r = els[i].getBoundingClientRect();
        if (r.height < 1) continue;
        var dy = parseFloat(els[i].getAttribute('data-hm-dy')) || 0;
        vis.push({ el: els[i], top: r.top - hr.top - dy, h: r.height, dy: dy });
      }
      if (!vis.length) continue;
      vis.sort(function (a, b) { return a.top - b.top; });
      var y = 0;
      for (i = 0; i < vis.length; i++) {
        var want = Math.round(y - vis[i].top);
        if (want !== vis[i].dy) {
          vis[i].el.style.position = want ? 'relative' : '';
          vis[i].el.style.top = want ? want + 'px' : '';
          vis[i].el.setAttribute('data-hm-dy', String(want));
        }
        y += vis[i].h + GAP;
      }
      var hpx = Math.ceil(y - GAP) + 'px';
      if (host.style.height !== hpx) {
        if (getComputedStyle(host).display === 'inline') host.style.display = 'block';
        host.style.height = hpx;
        host.style.overflow = 'hidden';
      }
    }
  }
  function sync() {
    var d = drawer();
    if (!d) return;
    if (MQ.matches && d.parentNode !== document.body) document.body.appendChild(d);
    var inner = d.querySelector('.drawer__inner');
    if (!inner) return;
    compact(d);
    var empty = d.classList.contains('is-empty'), wrap = inner.querySelector('.hm-cdd-wrap');
    if (empty && !wrap) {
      var t = document.getElementById('hm-cdd-empty-tpl');
      if (t && t.content) {
        wrap = document.createElement('div');
        wrap.className = 'hm-cdd-wrap';
        wrap.appendChild(t.content.cloneNode(true));
        var hd = inner.querySelector('.drawer__header');
        if (hd && hd.parentNode === inner) inner.insertBefore(wrap, hd.nextSibling); else inner.appendChild(wrap);
      }
    } else if (!empty && wrap) {
      wrap.parentNode.removeChild(wrap);
    }
    var items = inner.querySelector('cart-drawer-items'), ft = inner.querySelector('.drawer__footer');
    if (!items || !ft) return;
    var els = inner.querySelectorAll('.hm-cd-div, .hm-cd-save, .hm-cd-talk'), box = items.querySelector('.hm-cdd-more'), i;
    if (MQ.matches) {
      if (!box) { box = document.createElement('div'); box.className = 'hm-cdd-more'; items.appendChild(box); }
      for (i = 0; i < els.length; i++) { if (els[i].parentNode !== box) box.appendChild(els[i]); }
    } else {
      for (i = 0; i < els.length; i++) { if (els[i].parentNode !== ft) ft.appendChild(els[i]); }
      if (box) box.parentNode.removeChild(box);
    }
  }
  function boot() {
    cartIcon();
    sync();
    var d = drawer();
    if (d) new MutationObserver(later).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    if (MQ.addEventListener) MQ.addEventListener('change', sync); else if (MQ.addListener) MQ.addListener(sync);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
